module.exports = __webpack_public_path__ + "img/1504804598.ed5970b6.jpg";